import type { CreateSupportTicketDto } from '@paladin-monorepo/common';
import API from '../api';

export const supportApi = {
  async createTicket(dto: CreateSupportTicketDto): Promise<void> {
    await API.post('/support/tickets', dto);
  },
};
